import React from 'react';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import Label from 'components/form/Label/Label';
import { formatIncome } from 'helpers/money.helper';

const CreditAccountOverviewBox = props => {
  return (
    <FlexContainer
      className={
        'format100 margT8 border-rad8px justify-between grayShadow16 padT16 padB24 padLR16 flex-column'
      }
      style={{ height: '138px' }}
    >
      <Label className={'Subtitle-1'}>{'Overview'}</Label>
      <FlexContainer className={'justify-between'}>
        <Label className={'Body-2'}>{'Balance'}</Label>
        <Label className={'Body-2'}>{formatIncome(props.balance)}</Label>
      </FlexContainer>
      <FlexContainer className={'justify-between'}>
        <Label className={'Body-2'}>{'Credit Limit'}</Label>
        <Label className={'Body-2'}>{formatIncome(props.creditLimit)}</Label>
      </FlexContainer>
      <FlexContainer className={'justify-between'}>
        <Label className={'Body-2'}>{'Minimum payment'}</Label>
        <Label className={'Body-2'}>{formatIncome(props.monthlyPayment)}</Label>
      </FlexContainer>
    </FlexContainer>
  );
};

export default CreditAccountOverviewBox;
